import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Modal from "react-modal";
import Pagination from "../../../../components/Pagination";
import { useAuth } from "../../../../store/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AutoComplete } from "antd";
// import { formatNumber } from "../../../../components/formatNumber";

export const formatNumber = (num) => {
  if (num === null || num === undefined || num === "") return "0.00";

  const number = Number(num);

  if (isNaN(number)) return num;

  return number.toLocaleString("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const FarmerGoodsIssueReport = () => {
  const { orgData } = useAuth();
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };



  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      // border: "5px solid #96dc00",
    },
  };
  const frmRef = useRef({});
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);
  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();
  const [seasonId, setSeasonId] = useState("");
  const [seasonData, setSeasonData] = useState([]);
  const [ranchId, setRanchId] = useState();
  const [ranchData, setRanchData] = useState([]);
  const [fieldName, setFieldName] = useState("");
  const [fieldOptions, setFieldOptions] = useState([]);
  const [cropId, setCropId] = useState("");
  const [cropFilterList, setCropFilterList] = useState([]);

  const [collectionCenterId, setCollectionCenterId] = useState();
  const [collecticnCenterdata, setCollectionCenter] = useState([]);
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [fields, setFields] = useState([]);
  const [exportFields, setExportFields] = useState([]);
  const [exportHeaders, setExportHeaders] = useState([]);
  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const pdfContainerRef = useRef(null);
  const [pdfView, setPdfView] = useState(false);
  const [pdfData, setPdfData] = useState([]);

  const { sendRequest: getPdfData } = useHttp();
  const { sendRequest: getSeasonList } = useHttp();
  const { sendRequest: getCropList } = useHttp();

  useEffect(() => {
    getCropList(
      {
        url: `/api/farmerCropList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        console.log("Crop API Full Response:", res);
        setCropFilterList(res?.output);
      }
    );
  }, [getCropList]);
  const viewPdf = (data) => {
    setPdfView(true);

    const Id = data.goodIssueId || 0;
    if (Id) {
      getPdfData(
        {
          url: `/api/goodsIssueReport/?orgId=${localStorage.getItem(
            "orgId"
          )}&goodIssueId=${Id}`,
        },
        (data) => {
          setPdfData(data);
          console.log(data);
        }
      );
    }
  };

  const exportPDF = () => {
    if (!pdfContainerRef.current) return;

    const element = pdfContainerRef.current;
    const opt = {
      margin: 10,
      filename: "FarmerGoodsIssueReport.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "a4", orientation: "landscape" },
    };

    html2pdf().set(opt).from(element).save();
  };

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange",e.target.value)
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const loadCountData = (id) => {
    fillprocurementData(id);
  };

  const fillprocurementData = (
    employeeId,
    regionId,
    farmerNo = farmerNumber
  ) => {
    let urlfilter = "";

    if (showDateFilter && selectedFromDate && selectedToDate) {
      urlfilter += `&fromDate=${selectedFromDate}`;
      urlfilter += `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter += `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter += `&regionId=${regionId}`;
    }

    if (farmerNo) {
      urlfilter += `&farmerNo=${farmerNo}`;
    }

    if (ranchId > 0) {
      urlfilter = urlfilter + `&ranchId=${ranchId}`;
    }
    if (fieldName && fieldName !== "") {
      urlfilter += `&fieldId=${fieldName}`;
    }
    if (seasonId) {
      urlfilter += `&seasonId=${seasonId}`;
    }
    if (cropId !== "") {
      urlfilter += `&cropId=${cropId}`;
    }

    const url = `/api/goodsIssueReport/?page=${currentPage}&page_size=${itemsPerPage}&orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    getprocurementData({ url }, (res) => {
      setData(res?.results?.data || []);
      setTotalCount(res?.count || 0);

      if (res) {
        const activeFields = (res?.results?.fields || [])
          .filter((f) => f.status === 1)
          .sort((a, b) => a.sequenceNo - b.sequenceNo);
        setFields(activeFields);

        const exportFields = activeFields.map((f) => f.dataField);
        const headers = activeFields.map((f) => f.headerField);

        setExportFields(exportFields);
        setExportHeaders(headers);
      }
    });
  };

  const { sendRequest: getRanch } = useHttp();
  useEffect(() => {
    getRanch(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setRanchData(data);
      }
    );
  }, [getRanch]);

  useEffect(() => {
    fillprocurementData(employeeId, regionId);
  }, [
    currentPage,
    seasonId,
    employeeId,
    ranchId,
    fieldName,
    cropId
  ]);

  useEffect(() => {
    if (!ranchId) {
      setFieldOptions([]);
      return;
    }

    getprocurementData(
      {
        url: `/api/fieldList/?ranchId=${ranchId}`,
      },
      (res) => {

        const fieldList = res.map((f) => ({
          fieldCode: f,
        }));

        setFieldOptions(fieldList);
      }
    );
  }, [ranchId]);

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/region/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // sort by regionName in ascending order
        const sortedRegions = data.sort((a, b) =>
          a.regionName.localeCompare(b.regionName)
        );
        setRegionData(sortedRegions);
      }
    );
  }, [getRegion]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    var url = "";
    if (employeeId > 0) {
      url = url + '&fieldExecutiveId=' + employeeId;
    }

    if (seasonId > 0) {
      url = url + '&seasonId=' + seasonId;
    }

    if (ranchId > 0) {
      url = url + '&ranchId=' + ranchId;
    }


    getFarmerNumber(
      {
        url: `/api/goodsIssueFarmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}${url}`,
      },
      (data) => {
        setFarmerData(data);
      }
    );
  }, [getFarmerNumber, employeeId, ranchId, seasonId]);

  useEffect(() => {
    getSeasonList(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setSeasonData(data);
      }
    );
  }, [getSeasonList]);

  const handleSearch = (value) => {
    setFarmerNumber(value);
    fillprocurementData(employeeId, regionId, value); // pass value explicitly
  };

  const filteredOptions = farmerData
    ?.filter((item) =>
      item.farmerNo.toLowerCase().includes(farmerNumber.toLowerCase())
    )
    ?.map((item) => ({ value: item.farmerNo }));

  const [isPrinting, setIsPrinting] = useState(false);

  const [printData, setPrintData] = useState([]);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const modalRef = useRef(null);

  const openModal = () => {
    let urlfilter = "";

    if (employeeId > 0) {
      urlfilter += `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter += `&regionId=${regionId}`;
    }

    if (showDateFilter && selectedFromDate && selectedToDate) {
      urlfilter += `&fromDate=${selectedFromDate}`;
      urlfilter += `&toDate=${selectedToDate}`;
    }

    const url = `/api/goodsIssueDetailReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    getprocurementData({ url }, (res) => {
      setPrintData(res);
    });

    setModalIsOpen(true);
  };

  const handleExportExcel = () => {

    let urlfilter = "";

    if (showDateFilter && selectedFromDate && selectedToDate) {
      urlfilter += `&fromDate=${selectedFromDate}`;
      urlfilter += `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter += `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter += `&regionId=${regionId}`;
    }

    if (farmerNumber) {
      urlfilter += `&farmerNo=${farmerNumber}`;
    }

    if (ranchId > 0) {
      urlfilter += `&ranchId=${ranchId}`;
    }

    if (fieldName && fieldName !== "") {
      urlfilter += `&fieldId=${fieldName}`;
    }

    if (seasonId) {
      urlfilter += `&seasonId=${seasonId}`;
    }

    if (cropId !== "") {
      urlfilter += `&cropId=${cropId}`;
    }

    const exportUrl = `/api/goodsIssueReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    getprocurementData({ url: exportUrl }, (res) => {

      const fullData = res?.data || [];

      if (!fullData.length) {
        toast.error("No data available to export!");
        return;
      }

      const filename = "FarmerGoodsIssuedReport.xlsx";

      const processedData = fullData.map((item) => {
        const row = {};

        exportFields.forEach((key) => {
          row[key] = item[key] ?? "";
        });

        return row;
      });

      convertToExcel(
        processedData,
        exportFields,
        filename,
        exportHeaders
      );
    });
  };

  const handlePrint = () => {
    setIsPrinting(true);

    const input = modalRef.current; // The modal content

    const pdf = new jsPDF("p", "mm", "a4");

    const margin = 10; // Margin from all sides
    const imgWidth = 210 - 2 * margin; // A4 width minus margins
    const pageHeight = 297 - 2 * margin; // A4 height minus margins
    let yPosition = margin; // Initial Y position for the first page

    const tableElements = input.querySelectorAll(".print-section");

    const captureAndPrintElement = (element, callback) => {
      html2canvas(element, {
        scale: 2,
        ignoreElements: (element) => element.classList.contains("no-print"),
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        if (yPosition + imgHeight > pageHeight) {
          pdf.addPage();
          yPosition = margin;
        }

        pdf.addImage(imgData, "PNG", margin, yPosition, imgWidth, imgHeight);
        yPosition += imgHeight + 5;
        callback();
      });
    };

    const processElements = (index) => {
      if (index < tableElements.length) {
        captureAndPrintElement(tableElements[index], () => {
          processElements(index + 1);
        });
      } else {
        pdf.save("FarmerGoodsIssue.pdf");
        setIsPrinting(false);
      }
    };

    processElements(0);
  };

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "15%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "800px",
      maxHeight: "450px",
      height: "100%",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };

  return (
    <div className="content-wrapper">
      <div className="row mx-2 mt-3">
        <div className="col-md-8">
          <label className="card-title mx-3">
            Farmer Input Loan Detail
          </label>
        </div>
        <div className="col-md-4 text-right">
          <button className="btn btn-tool" onClick={handleButtonClick}>
            <i className="fas fa-times" />
          </button>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <hr />
          <div className="row">
            <div className="col-md-3">
              <label>Crop Name</label>

              <select
                className="form-control"
                value={cropId}
                onChange={(e) => {
                  setCropId(e.target.value);
                  setData([]);
                }}
              >
                <option value="">Select</option>

                {cropFilterList &&
                  cropFilterList.map((x) => (
                    <option key={x.CropId} value={x.CropId}>
                      {x.CropName}
                    </option>
                  ))}
              </select>
            </div>

            <div className="col-md-3">
              <label>Season Name</label>
              <select
                className="form-control"
                value={seasonId}
                onChange={(e) => {
                  setSeasonId(+e.target.value || 0);
                  setData([]);
                }}
              >
                <option value="0">--Select--</option>

                {seasonData.map((x) => (
                  <option key={x.seasonId} value={x.seasonId}>
                    {x.seasonName}
                  </option>
                ))}
              </select>
            </div>


            <div className="col-md-3">
              <div className="form-group">
                <label>Ranch</label>
                <select
                  id="ranch"
                  className="form-control"
                  value={ranchId}
                  onChange={(e) => {
                    setRanchId(e.target.value || 0);
                    setFieldName("");
                    setData([]);
                  }}
                >
                  <option value="">Select</option>
                  {ranchData &&
                    ranchData.map((x) => (
                      <option key={x.ranchId} value={x.ranchId}>
                        {x.ranchName}
                      </option>
                    ))}
                </select>
              </div>
            </div>


            <div className="col-md-3">
              <div className="form-group">
                <label>Field Name</label>
                <select
                  className="form-control"
                  value={fieldName}
                  onChange={(e) => {
                    setFieldName(e.target.value);
                  }}
                >
                  <option value="">Select</option>

                  {fieldOptions.map((x, i) => (
                    <option key={i} value={x.fieldCode}>
                      {x.fieldCode}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* <div className="col-md-3">
              <label>Field Officer</label>
              <select
                className="form-control"
                value={employeeId}
                onChange={(e) => {
                  setEmployeeId(+e.target.value || 0);
                  setData([]);
                }}
              >
                <option value="0">--Select--</option>
                {employeeData.map((x) => (
                  <option key={x.userId} value={x.userId}>
                    {x.employeeName}
                  </option>
                ))}
              </select>
            </div> */}



            {/* Farmer Number */}
            <div className="col-md-3">
              <label htmlFor="farmer_number">Farmer Number</label>
              <AutoComplete
                className="form-control"
                style={{ height: "30px" }}
                value={farmerNumber}
                options={filteredOptions}
                placeholder="Farmer Number"
                onChange={handleSearch}
              />
            </div>

            <div className="col-md-3">
              <label>Apply Date Filter</label>
              <select
                className="form-control"
                onChange={handleDateFilterChange}
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>

            {showDateFilter && (
              <>
                <div className="col-md-3">
                  <label>From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                    max={new Date().toISOString().slice(0, 10)}
                  />
                </div>
                <div className="col-md-3">
                  <label>To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={selectedToDate}
                    onChange={handleTDateChange}
                    max={new Date().toISOString().slice(0, 10)}
                  />
                </div>
              </>
            )}

            <div className="col-md-2 align-self-end">
              <br></br>
              <button
                className="btn btn-sm btn-primary form-control"
                onClick={() => fillprocurementData(employeeId, regionId)}
              >
                Submit
              </button>
            </div>
          </div>
          <h5 className="mt-3">
            Please select the parameters to get the desired result
          </h5>
          <hr />
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="text-right my-2">
            {/* <button className="btn btn-sm btn-success" onClick={openModal}>
              <i className="fas fa-print"></i>
            </button> */}
            <button
              className="btn btn-sm btn-warning mx-2"
              onClick={handleExportExcel}
            >
              <i className="fas fa-file-excel"></i>
            </button>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body" style={{ padding: "0.4rem" }}>
                  <table className="table table-bordered table-responsive text-center table-sm">
                    <thead>
                      <tr className="table-header">
                        {fields?.map((field, index) => (
                          <th key={index}>{field.headerField}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((itm, i) => (
                        <tr key={i} className="tablerowview">
                          {fields?.map((field, j) => {
                            const value = itm[field.dataField];

                            if (field.dataField === "urlProfile") {
                              return (
                                <td key={j}>
                                  <img
                                    src={`${process.env.REACT_APP_FILE_URL}${value}`}
                                    className="user-image img-circle"
                                    width="60"
                                    height="60"
                                    alt="Profile"
                                  />
                                </td>
                              );
                            }

                            if (field.dataField === "urlAttachment") {
                              return (
                                <td key={j}>
                                  <a
                                    href={`${process.env.REACT_APP_FILE_URL}${value}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Id Proof
                                  </a>
                                </td>
                              );
                            }

                            if (field.dataField === "signatureAttachment") {
                              return (
                                <td key={j}>
                                  <img
                                    src={`${process.env.REACT_APP_FILE_URL}${value}`}
                                    className="user-image img-circle"
                                    alt="Signature"
                                    height="60"
                                    width="60"
                                  />
                                </td>
                              );
                            }
                            const amountFields = [
                              "amount",
                              "cost",
                              "totalAmount",
                              "netAmount",
                              "price",
                              "totalCost",
                              "loanPayment",
                              "loanBalance",
                              "farmerTotalHarvest",
                            ];

                            if (amountFields.includes(field.dataField)) {
                              return <td key={j}>{formatNumber(value)}</td>;
                            }

                            return <td key={j}>{value}</td>;
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="card-footer clearfix">
                  <Pagination
                    totalItems={totalCount}
                    itemsPerPage={itemsPerPage}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FarmerGoodsIssueReport;
